<script setup lang="ts">
  import type { SelectItemProps } from "reka-ui";
  import type { HTMLAttributes } from "vue";
  import { reactiveOmit } from "@vueuse/core";
  import { Check } from "lucide-vue-next";
  import { SelectItem, SelectItemIndicator, SelectItemText, useForwardProps } from "reka-ui";
  import { cn } from "@/lib/utils";

  const props = defineProps<SelectItemProps & { class?: HTMLAttributes["class"]; title?: string }>();

  const delegatedProps = reactiveOmit(props, "class");

  const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <SelectItem
    data-slot="select-item"
    v-bind="forwardedProps"
    :class="
      cn(
        'focus:bg-accent focus:text-accent-foreground [&_svg:not([class*=\'text-\'])]:text-muted-foreground flex w-full cursor-pointer items-center gap-2 rounded-sm py-1.5 px-2 text-13 outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*=\'size-\'])]:size-4',
        props.class,
      )
    ">
    <SelectItemText
      class="min-w-0 flex-1 block truncate"
      :title="title">
      <slot />
    </SelectItemText>
    <span class="shrink-0 flex size-4 items-center justify-center">
      <SelectItemIndicator>
        <slot name="indicator-icon">
          <Check class="size-4" />
        </slot>
      </SelectItemIndicator>
    </span>
  </SelectItem>
</template>
